import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Button } from 'primeng/button';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'd2d-page-not-found',
  imports: [Button, RouterLink, TranslocoPipe],
  templateUrl: './page-not-found.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './page-not-found.component.scss',
})
export class PageNotFoundComponent implements OnInit {
  /** Cantidad de mensajes definidos en pageNotFound.messages (i18n). */
  private static readonly MESSAGE_COUNT = 9;

  messageIndex = 0;

  ngOnInit() {
    // this.randomMessage();
    this.changeMessage();
  }

  randomMessage() {
    const _interval = setInterval(() => {
      this.changeMessage();
    }, 7000);
  }

  changeMessage() {
    this.messageIndex = Math.floor(Math.random() * PageNotFoundComponent.MESSAGE_COUNT);
  }
}
